"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mapProps = function (prop, map) {
    if (typeof prop === "string" || typeof prop === "boolean") {
        return map[String(prop)];
    }
    var keys = Object.keys(prop);
    return keys.reduce(function (acc, key) {
        var value = String(prop[key]);
        acc[key] = map[value];
        return acc;
    }, { s: map[String(prop.s)] });
};
exports.default = mapProps;
